import { Money as PBMoney } from "gen/proto/money/models_pb"
import { Money } from "shared-ts/classes/money"

import { data } from "./data"
import { TypedAccessor } from "./types"
import { TableCellWidth } from "../TableCell"
import { DataColumn } from "../useTable/types"

type MoneyAccessorFn<T> = TypedAccessor<T, PBMoney | undefined>
type MoneyColumn<T> = Omit<DataColumn<T>, "type" | "renderCell" | "width"> & {
  width?: TableCellWidth
}
export type MoneyColumnHelper<T> = (
  accessorFn: MoneyAccessorFn<T>,
  col: MoneyColumn<T>
) => DataColumn<T>

export function money<T>(
  accessorFn: MoneyAccessorFn<T>,
  col: MoneyColumn<T>
): DataColumn<T> {
  return data({
    renderCell: (rowData) => {
      const value = accessorFn(rowData)
      if (!value) return null
      return Money.fromPB(value).format()
    },
    width: TableCellWidth.Medium,
    ...col,
  })
}
